var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPill02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75691 17.9957C4.70344 20.3199 4.92552 23.8692 7.25165 25.9212C9.58061 27.9766 13.1306 27.7498 15.1776 25.4265L20.2196 19.7136L18.2624 14.0886L11.8007 12.2814L6.75691 17.9957Z",
    fill: "#F5BABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.838 6.5657L11.7958 12.2801L20.2164 19.7125L20.2179 19.7127L25.2601 13.9982C27.3137 11.6724 27.0917 8.12313 24.7671 6.07135C22.4483 4.02491 18.8965 4.2388 16.8396 6.56586L16.838 6.5657Z",
    fill: "#E55151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPill02);
export default __webpack_public_path__ + "static/media/i_pill_02.b8d18ad20386f228570cf66c77e87bd8.svg";
export { ForwardRef as ReactComponent };